<template>
  <div class="modal fade show d-block" tabindex="-1" style="background-color: rgba(0,0,0,0.5)">
    <div class="modal-dialog modal-lg">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Editar Administrador</h5>
          <button type="button" class="btn-close" @click="$emit('close')"></button>
        </div>
        
        <div class="modal-body">
          <form @submit.prevent="handleSubmit">
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Nombre</label>
                  <input 
                    v-model="formData.firstname" 
                    type="text" 
                    class="form-control"
                    :class="{ 'is-invalid': validation.firstname.error }"
                    required
                  />
                  <div v-if="validation.firstname.error" class="invalid-feedback">
                    {{ validation.firstname.message }}
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Apellido</label>
                  <input 
                    v-model="formData.lastname" 
                    type="text" 
                    class="form-control"
                    :class="{ 'is-invalid': validation.lastname.error }"
                    required
                  />
                  <div v-if="validation.lastname.error" class="invalid-feedback">
                    {{ validation.lastname.message }}
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Email</label>
                  <input 
                    v-model="formData.email" 
                    type="email" 
                    class="form-control"
                    :class="{ 'is-invalid': validation.email.error }"
                    @blur="validateEmail"
                    required
                  />
                  <div v-if="validation.email.error" class="invalid-feedback">
                    {{ validation.email.message }}
                  </div>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Teléfono</label>
                  <input 
                    v-model="formData.cellphone" 
                    type="tel" 
                    class="form-control"
                    :class="{ 'is-invalid': validation.cellphone.error }"
                  />
                  <div v-if="validation.cellphone.error" class="invalid-feedback">
                    {{ validation.cellphone.message }}
                  </div>
                </div>
              </div>
            </div>
            
            <div class="row">
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Rol</label>
                  <select v-model="formData.rol" class="form-control" required>
                    <option value="admin">Administrador</option>
                    <option value="superadmin">Super Administrador</option>
                  </select>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-group mb-3">
                  <label class="form-label">Cliente</label>
                  <select v-model="formData.client_id" class="form-control" required>
                    <option v-for="client in clients" :key="client.id" :value="client.id">
                      {{ client.name }}
                    </option>
                  </select>
                </div>
              </div>
            </div>
            
            <div class="form-group mb-3">
              <label class="form-label">Cargo</label>
              <input 
                v-model="formData.position" 
                type="text" 
                class="form-control"
              />
            </div>
          </form>
        </div>
        
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="$emit('close')">
            Cancelar
          </button>
          <button 
            type="button" 
            class="btn btn-primary" 
            @click="handleSubmit"
            :disabled="isSubmitting"
          >
            {{ isSubmitting ? 'Guardando...' : 'Guardar cambios' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export default {
  name: 'ModalEditUser',
  
  props: {
    user: { type: Object, required: true },
    token: { type: String, required: true },
    empresas: { type: Array, default: () => [] },
    clients: { type: Array, default: () => [] }
  },
  
  emits: ['user-updated', 'close'],
  
  data() {
    return {
      formData: { ...this.user },
      isSubmitting: false,
      validation: {
        firstname: { error: false, message: '' },
        lastname: { error: false, message: '' },
        email: { error: false, message: '' },
        cellphone: { error: false, message: '' }
      }
    };
  },
  
  methods: {
    async handleSubmit() {
      if (this.isSubmitting) return;
      
      this.isSubmitting = true;
      
      try {
        const response = await axios.put(`/api/users/${this.user.id}`, this.formData, {
          headers: {
            'Authorization': `Bearer ${this.token}`,
            'Content-Type': 'application/json'
          }
        });
        
        this.$emit('user-updated', response.data);
        
        this.$swal.fire({
          title: 'Éxito!',
          text: 'Administrador actualizado correctamente.',
          icon: 'success'
        });
        
        this.$emit('close');
        
      } catch (error) {
        console.error('Error updating user:', error);
        
        const errors = error.response?.data?.errors || {};
        this.handleValidationErrors(errors);
        
        this.$swal.fire({
          title: 'Error!',
          text: error.response?.data?.message || 'Hubo un error al actualizar el administrador.',
          icon: 'error'
        });
      } finally {
        this.isSubmitting = false;
      }
    },
    
    handleValidationErrors(errors) {
      Object.keys(this.validation).forEach(field => {
        this.validation[field] = {
          error: !!errors[field],
          message: errors[field] ? errors[field][0] : ''
        };
      });
    },
    
    validateEmail() {
      const email = this.formData.email;
      
      if (!email) {
        this.validation.email = { error: true, message: 'El email es requerido' };
        return;
      }
      
      if (!EMAIL_REGEX.test(email)) {
        this.validation.email = { error: true, message: 'El formato del email no es válido' };
        return;
      }
      
      this.validation.email = { error: false, message: '' };
    }
  }
}
</script>

<style scoped>
.form-label {
  color: #1A0054;
  font-weight: 500;
}

.is-invalid {
  border-color: #dc3545;
}

.invalid-feedback {
  display: block;
  width: 100%;
  margin-top: 0.25rem;
  font-size: 0.875em;
  color: #dc3545;
}
</style>